import React, { useRef, useState } from "react";
import "../style/CarCarousel.css";
import LeadPopup from "./LeadPopup";

const CarCarousel = ({ title, data }) => {
  const scrollRef = useRef(null);
  const [popupData, setPopupData] = useState(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const { clientWidth } = scrollRef.current;
      const scrollAmount = direction === "left" ? -clientWidth : clientWidth;
      scrollRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="section-container">
      <div className="sections-header">
        <h2>{title}</h2>
        <button className="view-all-btn">View All {title} ›</button>
      </div>

      <div className="carousel-wrapper">
        <button className="nav-btn left" onClick={() => scroll("left")}>
          ‹
        </button>
        <button className="nav-btn right" onClick={() => scroll("right")}>
          ›
        </button>

        <div className="cards-scroll-container" ref={scrollRef}>
          {data.map((car, index) => (
            <div className="car-card" key={index}>
              <div className="image-wrapper">
                {car.status && (
                  <div className="launch-badge">{car.status}</div>
                )}
                <img src={car.image} alt={car.name} />
                {car.isElectric && <div className="ev-tag">⚡ Electric</div>}
              </div>

              <div className="car-details">
                <h3 className="car-title">{car.name}</h3>
                <p className="car-price-tag">
                  ₹{car.price}{" "}
                  <span className="price-type">Onwards</span>
                </p>

                <button
                  className="action-button"
                  onClick={() =>
                    setPopupData({
                      carName: car.name,
                      type: title.includes("Upcoming")
                        ? "alert"
                        : "offer",
                    })
                  }
                >
                  {title.includes("Upcoming")
                    ? "Alert Me When Launched"
                    : "Check January Offers"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* POPUP */}
      {popupData && (
        <LeadPopup
          carName={popupData.carName}
          type={popupData.type}
          onClose={() => setPopupData(null)}
        />
      )}
    </div>
  );
};

export default CarCarousel;
